export const useDialog = () => {
  const shouldShow:Ref<boolean> = useState(() => ref(false))
  const type: Ref<string> = useState(() => ref('confirm'))
  const message: Ref<string> = useState(() => ref(''))
  const promiseState: Ref<string> = useState(() => ref(''))

  const resolve:any = async () => {
    promiseState.value = 'resolved'
    shouldShow.value = false
    await nextTick()
    promiseState.value = ''
  }

  const reject = async () => {
    promiseState.value = 'rejected'
    shouldShow.value = false
    await nextTick()
    promiseState.value = ''
  }

  const showDialog = (dialogMessage: string) => {
    shouldShow.value = true
    type.value = 'confirm'
    message.value = dialogMessage

    return new Promise<void>((resolve, reject) => {
      watch(promiseState, value => {
        if (value === 'resolved') {
          resolve()
        } else if (value === 'rejected') {
          reject('showDialog rejected')
        }
      }, { once: true })
    })
  }

  const showAlert = (dialogMessage: string) => {
    shouldShow.value = true
    type.value = 'alert'
    message.value = dialogMessage

    return new Promise<void>((resolve, reject) => {
      watch(promiseState, value => {
        if (value === 'resolved') {
          resolve()
        } else if (value === 'rejected') {
          reject('showAlert rejected')
        }
      }, { once: true })
    })
  }

  return { showDialog, showAlert, resolve, reject, shouldShow, type, message }
}
